<template>
    <div>
        <!-- 重大事件 -->
        <Row style="margin-bottom: 20px;">
            <Col span="24">
                <Card >
                    <Row>
                        <Col span="20" class="title">重大事件</Col>
                        <Col style="float: right;">
                            <Button @click="addMajorEventModal" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:add_important_event']">添加</Button>
                        </Col>
                    </Row>
                    <!-- 重大事件 -->
                 	<Table :no-data-text="$t('common.noData')" class="table-css" height="1660" :columns="majorEventColumn" :data="majorEventDate" :loading="majorEventLoading">
                 		<template slot-scope="{row,index}" slot="delete">
			                <span @click="doDelete(index)">
			                    <Button type="error" size="small" @click="majorEventDelModal = true" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:delete_important']">{{ $t('ticket.list.delete') }}</Button>
			                </span>
			            </template>
                 	</Table>
                </Card>
            </Col>
        </Row>
        <!-- 重大事件删除 -->
        <Modal v-model="majorEventDelModal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('alarms.common.sureDelete')}} {{name}} {{ $t('alarms.common.what') }}?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="modal_loading" @click="removeMajorEvent()" :disabled="isDisableDelete">{{ $t('ticket.list.delete') }}</Button>
            </div>
        </Modal>
        <!-- 重大事件添加 -->
        <Modal v-model="majorEventModal" :title="!majorEventForm.id ? '添加':'编辑'" :loading="loadingMajorEvent" @on-ok="majorEventSubmit('majorEventForm')" @on-cancel="majorEventReset('majorEventForm')" :mask-closable="false">
            <Form ref="majorEventForm" :model="majorEventForm" :label-width="100" :rules="ruleValidate">
                <!-- 主题 -->
                <FormItem label="主题" prop="subject">
                    <Input v-model="majorEventForm.subject" type="textarea" :autosize="{minRows: 2,maxRows: 5}" style="width:300px;"></Input>
                </FormItem>

                <!-- 问题描述 -->
                <FormItem label="问题描述" prop="description">
                    <Input v-model="majorEventForm.description" type="textarea" :autosize="{minRows: 2,maxRows: 5}" style="width:300px;"></Input>
                </FormItem>

                <!-- 事件进展 -->
                <FormItem label="事件进展" prop="progress">
                    <Input v-model="majorEventForm.progress" type="textarea" :autosize="{minRows: 2,maxRows: 5}" style="width:300px;"></Input>
                </FormItem>

                <!-- 事件结果 -->
                <FormItem label="事件结果" prop="result">
                    <Input v-model="majorEventForm.result" type="textarea" :autosize="{minRows: 2,maxRows: 5}" style="width:300px;"></Input>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
    var majorEventVue = {}
    export default {
        name: 'MajorEvent',
        data(){
            return {
                accountIdList:[],
                reportId:0,
                companyId:0,
                reportDate:'',  //初始化传参
                name:'',
                modal_loading: false, 
                majorEventDelModal:false,
                isDisableDelete: false,   //删除
                majorEventLoading:false,
            	loadingMajorEvent: true,
                majorEventModal: false,
                majorEventForm: {
                    subject:'',
                    description:'',
                    progress:'',
                    result:''
                },     
                majorEventColumn: [
                {
                    title: '主题',
                    key: 'eventTitle',
                    render: (h,params) => {
                        return h('a',{
                            style: {
                                textDecoration: 'underline'
                            },
                            on: {
                                click: () => {
                                    this.majorEventForm.id = params.row.id;
                                    this.majorEventModal=true;
                                    // 主题
                                    this.majorEventForm.subject=params.row.eventTitle;
                                    // 问题描述
                                    this.majorEventForm.description=params.row.eventDescribe;
                                    // 事件进展
                                    this.majorEventForm.progress=params.row.eventProgress;
                                    // 事件结果
                                    this.majorEventForm.result=params.row.eventResult;
                                }
                            }
                        },params.row.eventTitle);
                    }
                },
                {
                    title: '问题描述',
                    key: 'eventDescribe'
                },
                {
                    title: '事件进展',
                    key: 'eventProgress'
                },
                {
                    title: '事件结果',
                    key: 'eventResult'
                },
                {
                    title:'操作',
                    slot:'delete'
                }],                   
                ruleValidate: {
                    subject: [
                        { required: true, message: '请输入主题', trigger: 'blur'}
                    ],
                    description: [
                        { required: true, message: '请输入问题描述', trigger: 'blur'}
                    ],
                    progress: [
                        { required: true, message: '请输入事件进展', trigger: 'blur'}
                    ],
                    result: [
                        { required: true, message: '请输入事件结果', trigger: 'blur'}
                    ]
                },
                majorEventDate:[]
            }
        },
        beforeCreate: function() {
            majorEventVue = this
        },
        mounted () {
            majorEventVue.selectReportEventList();
        },
        created(){
            // 初始化参数
            this.accountIdList=JSON.parse(this.$route.query.accountIdList);
            this.reportId=Number(this.$route.query.reportId);
            this.companyId=Number(this.$route.query.companyId);
            this.reportDate=this.$route.query.reportDate;
        },
        methods: {
        	/*****************重大事件*************************************/ 
            // 添加
            addMajorEventModal:function(){
                this.majorEventModal=true;
            },
        	// 表格
            selectReportEventList:function(){
                this.majorEventLoading = true;
                this.$api.reportEvent.selectReportEventList({
                    "reportId": this.reportId
                })
                .then(res => {
                    this.majorEventDate = res.data;
                    this.majorEventLoading = false;
                })
            },
            // 删除
            /****************************************************/
            doDelete: function(index){
                this.lineIndex=index;
                this.name=this.majorEventDate[index].eventTitle;
            },
            removeMajorEvent: function(){
                this.isDisableDelete = true;  //开始可以点击
                var lineIndex=this.lineIndex;
                //删除
                this.$api.reportEvent.deleteReportEvent({
                    "id":this.majorEventDate[lineIndex].id
                })
                .then(res => {
                    this.modal_loading = true;
                    setTimeout(() => {
                        // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                        //21条  3页  2*10+1时删除
                        if(lineIndex==0&&((this.current-1)*this.pageSize+1)==this.dataTotal){
                            this.current=this.current-1;
                        }
                        this.dataTotal=this.dataTotal-1;
                        majorEventVue.selectReportEventList();
                        this.isDisableDelete = false;
                        this.modal_loading = false;
                        this.majorEventDelModal = false;
                        this.$Message.success('删除成功');
                    }, 1000);
                })
            },
            /*****************添加&编辑*************************************/ 
            majorEventSubmit: function (name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        // 添加&编辑
                        var patchCommandPropertyDTO = {
                            "reportId" : this.reportId,
                            "eventTitle" : this.majorEventForm.subject,
                            "eventDescribe": this.majorEventForm.description,
                            "eventProgress" : this.majorEventForm.progress,
                            "eventResult" : this.majorEventForm.result
                        }
                        if(this.majorEventForm.id>0){
                            patchCommandPropertyDTO.id=this.majorEventForm.id;
                            // 编辑
                            this.$api.reportEvent.updateReportEvent(patchCommandPropertyDTO)
                            .then(res => {
                                setTimeout(() => {
                                    majorEventVue.selectReportEventList();
                                    this.$refs[name].resetFields();
                                    this.loadingMajorEvent = false;
                                    this.$nextTick(() => {
                                        this.loadingMajorEvent = true;
                                    });
                                    this.$Message.success('编辑成功');
                                    this.majorEventModal = false;
                                }, 1000);
                            })
                        }else{
                            // 添加
                            this.$api.reportEvent.addReportEvent(patchCommandPropertyDTO)
                            .then(res => {
                                setTimeout(() => {
                                    majorEventVue.selectReportEventList();
                                    this.$refs[name].resetFields();
                                    this.loadingMajorEvent = false;
                                    this.$nextTick(() => {
                                        this.loadingMajorEvent = true;
                                    });
                                    this.$Message.success('添加成功');
                                    this.majorEventModal = false;
                                }, 1000);
                            })
                        }
                        
                    } else {
                        this.loadingMajorEvent = false;
                        setTimeout(() => {
                            this.loadingMajorEvent = true
                        }, 0)
                        if (this.majorEventForm.id>0) {
                            this.$Message.error('编辑失败');
                        } else {
                            this.$Message.error('添加失败');
                        }
                    }
                });
            },
            majorEventReset: function (name) {
                this.$refs[name].resetFields();
            }
        }
    }
</script>

<style scoped>
    .title
    {
        font-size:14px;
        font-weight: 600;
        float:left;
        color:#000;
        margin-bottom: 30px;
    }
	/* 滚动条 */
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #ccc;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
        background: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
        background-color: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowX{
        overflow-x: hidden !important;
    }
    .title
    {
        font-size:13px;
        font-weight: 600;
        float:left;
        color:#000;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/operation_report/report_configuration/MajorEvent.vue